import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

interface IAlertDialogButton {
    label: string;
    value: any;
}

interface IAlertDialogProps {
    title: string;
    message: string;
    buttons: IAlertDialogButton[];
    isOpen: boolean;
    onClose?: (value: any) => void;
}

const AlertDialog: React.FunctionComponent<IAlertDialogProps> = (props: IAlertDialogProps) => {
    return (
        <Dialog
            open={props.isOpen}
            /*onClose={() => props.onClose && props.onClose(undefined)}*/
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description">
            <DialogTitle id="alert-dialog-title">{props.title}</DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">{props.message}</DialogContentText>
            </DialogContent>
            <DialogActions>
                {props.buttons.map((b, i) => (
                    <Button key={i} onClick={() => props.onClose && props.onClose(b.value)}
                            color="primary">{b.label}</Button>
                ))}
            </DialogActions>
        </Dialog>
    );
}

export default AlertDialog;